
import {
  getParticipantsByEstaId,
  getParticipantById,
  setParticipant,
  getMappedParticipants,
  setMappingParticipant
} from '../api/participants';


function removeTime(sdate) {
  if (!sdate) return null;
  return sdate.split('T')[0];
}

function OrderByFullName(a, b){

  const nameA = a.fullname.toUpperCase(); // ignore upper and lowercase
  const nameB = b.fullname.toUpperCase(); // ignore upper and lowercase
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }
  return 0;
}


export async function getParticipantsForEstablishment(estaId) {
  return getParticipantsByEstaId(estaId);
}

export async function getParticipant(estaId, id) {
  const participant = await getParticipantById(estaId, id);
  if (participant) participant.par_birthday = removeTime(participant.par_birthday);
  return participant;
}

export async function updateParticipant(estaId, participant){
  const par = { ...{esta_id: estaId}, ...participant};
  return setParticipant(par)
}


export async function MappedParticipants(estaId, cntId){
 const data  = await getMappedParticipants(estaId, cntId);
 if (data) {

  const result = data.map(p=>{
    p.fullname = `${p.par_lastname} ${p.par_firstname}`;
    p.saved = (p.ext_uri !== null);
    p.birthyear = new Date(p.par_birthday).toLocaleDateString();
    return p;
  })
  return result.sort(OrderByFullName);
 }
}

export async function SetParticipantUri(estaId, cntId, pareId, uri){
  const data = await setMappingParticipant({esta_id: estaId, cnt_id: cntId, pare_id: pareId, ext_uri: uri});

  if (data && data?.peec_id > 0) return true;

  return false;
}